/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum BundleTypeEnum {
    UNKNOWN = 'UNKNOWN',
    PARTS_BUNDLING = 'PARTS_BUNDLING',
    TE_MINUTES_BUNDLING = 'TE_MINUTES_BUNDLING'
}
